// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper_title":"InformationModal_modalWrapper_title__2kYlJ","modalWrapper":"InformationModal_modalWrapper__3Zakz"};